import React from "react";

const MdmDeviceFieldScreenshotTab = ({ title, screenshotUrl, screenshotResult }) => (
  <div className="bg-surface-container-high rounded-lg p-4">
    {screenshotUrl ? (
      <>
        <img
          src={screenshotUrl}
          alt={`Field screenshot for ${title || "device"}`}
          className="w-full max-h-[55vh] object-contain rounded-lg border border-outline-variant/20 bg-black/5"
        />
        {screenshotResult?.updated_at && (
          <p className="mt-2 text-[11px] text-on-surface-variant">
            Last updated: {new Date(screenshotResult.updated_at).toLocaleString()}
          </p>
        )}
      </>
    ) : (
      <p className="text-xs text-on-surface-variant">
        No field screenshot found for this device yet. Run the <b>Screenshot</b> field command, then
        reopen this tab.
      </p>
    )}
  </div>
);

export default MdmDeviceFieldScreenshotTab;
